import CardService from "../api/card-service";
import { CARDS_API_URL, WALLET_API_URL } from "../api/urlMetaData";
import WalletService from "../api/wallet-service";
import { getCurrentFormattedDate } from "./utils";
import { downloadFile } from "./downloadFile";

// B2B Payments - Report Download
export const downloadReportB2B = async ({
  filename = "B2B_Report",
  email = "",
  clientHashId,
  userHashId,
  dateRange,
}) => {
  try {
    const url = `${WALLET_API_URL.DOWNLOAD_B2B_REPORT}?clientHashId=${clientHashId}&userHashId=${userHashId}&daterange=${dateRange}`;
    const res = await WalletService.get(url);
    if (res.data) {
      filename = `B2B_Report_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res.status === 200;
  } catch (error) {}
};

// Reports : Card Load
export const downloadReportingCardLoad = async ({
  filename = "Card_Load_Report",
  userHashId,
  dateRange,
  username,
  email = "",
}) => {
  try {
    const url = `${
      CARDS_API_URL.DOWNLOAD_CARD_LOAD_REPORT
    }?daterange=${dateRange}&username=${username}&fromUserHashId=${userHashId}&report=${true}`;

    const res = await CardService.post(url);
    if (res.data) {
      filename = `Card_Load_Report_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res?.data;
  } catch (error) {}
};

// Card Load - Report Download
export const downloadReportCardLoad = async ({
  filename = "Card_Load_Report",
  userHashId,
  dateRange,
  email = "",
}) => {
  try {
    const url = `${CARDS_API_URL.DOWNLOAD_CARD_LOAD_REPORT_CLIENT}/${userHashId}?daterange=${dateRange}`;
    const res = await CardService.get(url);
    if (res.data) {
      filename = `Card_Load_Report_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res?.data;
  } catch (error) {}
};

// Prefund - Report Download
export const downloadReporPrefund = async ({
  filename = "Prefund_Report",
  email = "",
  clientHashId,
  dateRange,
  userType,
}) => {
  try {
    const url = `${WALLET_API_URL.DOWNLOAD_PREFUND_REPORT}/${clientHashId}/program/all/prefundList/${userType}?daterange=${dateRange}`;
    const res = await WalletService.get(url);
    if (res.data) {
      filename = `Prefund_Report_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res.status === 200;
  } catch (error) {}
};

// Ledger - Report Download
export const downloadReportLedger = async ({
  filename = "Ledger_Report",
  email = "",
  userHashId,
  dateRange,
}) => {
  try {
    const url = `${WALLET_API_URL.DOWNLOAD_LEDGER_REPORT}?userHashId=${userHashId}&daterange=${dateRange}`;
    const res = await WalletService.get(url);
    if (res.data) {
      filename = `Ledger_Report_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res.status === 200;
  } catch (error) {}
};

// Driver Payment Request (Renamed as Claims and Advanced Requests) - Report Download
export const downloadReportDriverPaymentRequest = async ({
  filename = "Claims_Advance_Requests",
  email = "",
  userHashId,
  dateRange,
  username,
}) => {
  try {
    const url = `${WALLET_API_URL.DOWNLOAD_DPREQ_REPORT}?daterange=${dateRange}&userHashId=${userHashId}&username=${username}`;
    const res = await WalletService.get(url);
    if (res.data) {
      filename = `Claims_Advance_Requests_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res.status === 200;
  } catch (error) {}
};

// Driver Payment Request (Renamed as Claims and Advanced Requests) - Report Download
export const downloadPrefundRequestReport = async ({
  filename = "Prefund_Request_Report",
  email = "",
  userHashId,
  dateRange,
}) => {
  try {
    const url = `${WALLET_API_URL.DOWNLOAD_PREFUND_REQ_REPORT}/${userHashId}?daterange=${dateRange}`;
    const res = await WalletService.get(url);
    if (res.data) {
      filename = `Prefund_Request_Report_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res.status === 200;
  } catch (error) {}
};

// Requests Page

// B2B Payments - Report Download
export const downloadReportB2BRequests = async ({
  filename = "B2B_Requests_Report",
  email = "",
  userHashId,
  dateRange,
}) => {
  try {
    const url = `${WALLET_API_URL.DOWNLOAD_B2B_REQS_REPORT}?approverUserHashId=${userHashId}&daterange=${dateRange}`;
    const res = await WalletService.get(url);
    if (res.data) {
      filename = `B2B_Requests_Report_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res.status === 200;
  } catch (error) {}
};

// BRequests Page : Driver Payment Request (Renamed as Claims and Advanced Requests) Report Download
export const DownloadDriverPaymentRequestReport = async ({
  filename = "Claims_Advance_Requests",
  email = "",
  clientHashId,
  dateRange,
  userType,
}) => {
  try {
    const url = `${WALLET_API_URL.DOWNLOAD_DRIVER_REQS_REPORT}?clientHashId=${clientHashId}&daterange=${dateRange}&userType=${userType}`;
    const res = await WalletService.get(url);
    if (res.data) {
      filename = `Claims_Advance_Requests_${email}_${getCurrentFormattedDate()}.csv`;
      downloadFile(res.data, filename);
    }
    return res.status === 200;
  } catch (error) {}
};
